
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.706 10.203l3.953 4.392c.422.469 1.107.469 1.53 0 .422-.47.422-1.23 0-1.7l-2.107-2.34h7.547c.597 0 1.081-.538 1.081-1.202 0-.664-.484-1.202-1.081-1.202H6.082l2.106-2.34c.423-.47.423-1.23 0-1.7a1.007 1.007 0 00-1.53 0L2.707 8.503a1.298 1.298 0 000 1.7z","fill":"#282E3E"}})])
          )
        }
      }
    